// extracted by mini-css-extract-plugin
export var component = "PostsModuleBlocksItem-module--component--A4Q+P";